import styled from 'styled-components';
import { MyPriceWhiteButton } from '@/app/components/search/styles/buttons.ts';

export const BannerContainer = styled.div`
  background: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
  display: flex;

  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-radius: 8px;

  @media (max-width: 767px) {
    padding: 16px;
    flex-direction: column;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 12px;
  }
`;

export const BannerTextIcon = styled.div`
  flex-shrink: 0;
  margin-right: 16px;
  background-color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[500]};
  padding: 8px;
  border-radius: 8px;

  img {
    width: 36px;
    height: 36px;
  }
`;

export const BannerText = styled.div`
  width: 100%;
`;

export const BannerTextTitle = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('Title4')};
  color: white;
`;

export const BannerTextDescription = styled.div`
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
  color: white;
`;

export const BannerCta = styled.div`
  flex-shrink: 0;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const BannerCtaButton = styled(MyPriceWhiteButton)`
  color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};

  @media (max-width: 767px) {
    width: 100%;
  }
`;
